<template>
  <svg id="c-info-e" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      id="Shape"
      d="M8,16A7.99,7.99,0,0,1,2.35,2.35a7.99,7.99,0,1,1,11.3,11.3A7.942,7.942,0,0,1,8,16ZM8,2a6,6,0,1,0,6,6A6.007,6.007,0,0,0,8,2Z"
      transform="translate(0 0)"
      fill="currentColor"
    />
    <rect id="Rectangle" width="2" height="4.375" transform="translate(7 6.625)" fill="currentColor" />
    <ellipse id="Oval" cx="1" cy="0.875" rx="1" ry="0.875" transform="translate(7 4)" fill="currentColor" />
  </svg>
</template>
